export const accentColors = [
  { name: 'Purple', value: '#aa3bff' },
  { name: 'Blue', value: '#1976d2' },
  { name: 'Green', value: '#26e07f' },
  { name: 'Orange', value: '#ff9800' },
  { name: 'Magenta', value: '#e91e63' },
];

export const defaultAccentColor = accentColors[2].value;
